export default function Footer() {
    return (
      <footer className="footer">
        <small>
          Made by{" "}
          <a
            className="footer--link"
            href="https://emanueledelmonte.it"
            target="_blank"
            rel="noreferrer"
          >
           Kolade Abdulrahman
          </a>
          .
        </small>
      </footer>
    );
  }
  
  